export default function(fields) {
  return {
    isAddedByUser: true,
    isCompleted: fields.isCompleted,
    date: fields.date,
    name: fields.name,
    id: fields.id,
    helpers: undefined
  }
}
